import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8003';

/**
 * Send a chat message to the backend
 * @param {string} message - User message
 * @param {string|null} conversationId - Optional conversation ID
 * @returns {Promise} Response with answer and conversation ID
 */
export const sendChatMessage = async (message, conversationId = null) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/chat`, {
      message,
      conversation_id: conversationId
    });
    return response.data;
  } catch (error) {
    console.error('Error sending chat message:', error);
    throw error;
  }
};

/**
 * Health check
 * @returns {Promise} Health status
 */
export const checkHealth = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/health`);
    return response.data;
  } catch (error) {
    console.error('Error checking health:', error);
    throw error;
  }
};
